module.exports = __webpack_public_path__ + "img/photo_id_gen.a47b8aac.png";